import React from "react"
import styles from "./Heading.module.css"

const Heading = ({ size, children, className }) => {
  if (size === 1) {
    return <h1 className={`${styles.heading} ${styles.h1} ${className}`}>{children}</h1>
  } else if (size === 2) {
    return <h2 className={`${styles.heading} ${styles.h2} ${className}`}>{children}</h2>
  } else if (size === 3) {
    return <h3 className={`${styles.heading} ${styles.h3} ${className}`}>{children}</h3>
  } else if (size === 4) {
    return <h4 className={`${styles.heading} ${styles.h4} ${className}`}>{children}</h4>
  } else if (size === 5) {
    return <h5 className={`${styles.heading} ${styles.h5} ${className}`}>{children}</h5>
  } else if (size === 6) {
    return <h6 className={`${styles.heading} ${styles.h6} ${className}`}>{children}</h6>
  }
}

Heading.defaultProps = {
  size: 1,
}

export default Heading
